/**
 * The first step asks for an e-mail and a phone number, and either one can already belong to an
 * account. The backend answers that with a 409 naming the parameter(s) it collided on; this maps
 * those names to the copy each input shows.
 */

// Keys are the request parameter names the backend returns in `conflict_fields`, so a field it
// names that the first step does not ask for is simply not marked.
export const conflictCopyKeys: { [field: string]: string } = {
  email: 'onboarding-page:email_already_used_log_in',
  phone_number: 'onboarding-page:phone_number_already_used_log_in',
};

/**
 * The first-step fields a 409 says are already taken.
 *
 * Falls back to the e-mail, which is all a response without `conflict_fields` can have meant:
 * before the backend named the field, the e-mail was the only thing this ever blamed. That
 * fallback is what keeps a frontend deployed ahead of the backend behaving as it does today.
 */
export const conflictFieldsFrom = (namedByBackend: unknown): string[] => {
  const named = Array.isArray(namedByBackend) ? namedByBackend.filter((field) => field in conflictCopyKeys) : [];

  return named.length ? named : ['email'];
};
